/**
 * Schlage Engage gateway device types. Schlage introduced "gwe2" as a
 * hardware refresh of the original "gwe" gateway; for our purposes the two
 * device types should be treated identically everywhere gateway-ness is
 * checked on the client.
 */
export const GATEWAY_DEVICE_TYPES = ["gwe", "gwe2"] as const;

export const isGatewayDeviceType = (deviceType: string | undefined | null): boolean =>
  !!deviceType && (GATEWAY_DEVICE_TYPES as readonly string[]).includes(deviceType);
